import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchClaims = createAsyncThunk(
  "claims/fetchClaims",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/claims${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setClaimsAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Claims list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreClaims = createAsyncThunk(
  "claims/fetchMoreClaims",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/claims${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setClaimsAmount(response.headers["x-total-count"]));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreClaims(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const claimsSlice = createSlice({
  name: "claims",
  initialState: {
    claimsList: [],
    loading: "idle",
    error: "",
    claimsAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setClaimsAmount: (state, action) => {
      state.claimsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClaims.pending, (state) => {
      state.claimsList = [];

      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchClaims.fulfilled, (state, { payload }) => {
      state.claimsList = payload;

      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchClaims.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreClaims.fulfilled, (state, { payload }) => {
      state.error = "";
      state.claimsList = state.claimsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreClaims.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.claimsList = state.claimsList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setLastQuery, setClaimsAmount } = claimsSlice.actions;

export const selectClaims = createSelector(
  (state) => ({
    claimsList: state.claims.claimsList,
    loading: state.claims.loading,
    error: state.claims.error,
    claimsAmount: state.claims.claimsAmount,
    lastQuery: state.claims.lastQuery,
  }),
  (state) => state
);
export default claimsSlice.reducer;
